import { mapActions } from 'vuex';

const showAppMenu = {
  methods: {
    ...mapActions('app', ['showMenu']),
  },
};

export default showAppMenu;
